import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, isDevMode, inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FeedbackResponse } from 'src/app/page/main/components/feedback-form/feedback-form.component';
import { MainService } from 'src/app/page/main/main.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
declare var grecaptcha: any;

@Component({
  selector: 'app-anonymous-feedback',
  templateUrl: './anonymous-feedback.component.html',
  styleUrls: ['./anonymous-feedback.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
  ],
})
export class AnonymousFeedbackComponent implements OnInit, AfterViewInit {
  private mainService = inject(MainService);
  ntf = inject(NotificationService);
  private dialog = inject(MatDialog);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup = new FormGroup({
    url: new FormControl({
      value: '',
      disabled: true,
    }),
    subject: new FormControl('', Validators.required),
    text: new FormControl('', Validators.required),
  });
  siteKeyProd = '6Ldq5VUpAAAAAJvA-T4zqEu0xGIR0LngvLRdG5QP'; // ключ сайта reCAPTCHA
  siteKeyDev = '6Lfq5FUpAAAAANZ7VaKmG4AnRdNYe3ie5rQD8qyU'; // ключ сайта reCAPTCHA

  siteKey: string = window.location.href.includes('migration') ? this.siteKeyProd : this.siteKeyDev;

  isCaptchaValid: boolean = false;

  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  ngOnInit(): void {
    this.form.patchValue({
      url: location.href,
      subject: this.data,
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      grecaptcha.render(this.recaptchaElement.nativeElement, {
        sitekey: this.siteKey,
        callback: (response: string) => {
          this.isCaptchaValid = !!response;
        },
      });
    }, 100);
  }

  onSubmit() {
    const recaptchaResponse = this.recaptchaElement.nativeElement.querySelector('.g-recaptcha-response').value;
    if (this.form.valid && recaptchaResponse) {
      const data = this.form.getRawValue();
      const payload: FeedbackResponse = {
        subject: data?.subject,
        text: data?.text,
      };
      this.mainService.sendFeedback(payload, recaptchaResponse).subscribe({
        next: () => {
          this.form.reset();
          grecaptcha.reset();
          this.ntf.showNotification('snackbar-success', 'Ваше сообщение отправлено!');
          this.dialog.closeAll();
        },
        error: (err) => {
          console.error(err);
          this.ntf.showNotification('snackbar-danger', err?.error?.message || 'Ошибка отправки сообщения!');
        },
      });
    }
  }
}
